// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fcEa","largestCol":"styles_largestCol__1fsPy","smallestCol":"styles_smallestCol__BfwQ0"};